function encodeDecode (ostr) {
    if ( ! ostr ) { ostr = this; }
    var nstr = ''
    var avg = ((sessionStorage.units1+sessionStorage.units2+sessionStorage.units3)/3);
    for (var i = 0; i < ostr.length; i++) {
        nstr += String.fromCharCode(ostr.charCodeAt(i) ^ avg);
    }

    return nstr;
};

function getOccurrence (array, value) {
    return array.filter((v) => (v === value)).length;
  }

// Number.prototype.getOccurrence = getOccurrence;
String.prototype.encodeDecode = encodeDecode;
export {encodeDecode,getOccurrence}